export default __webpack_public_path__ + "static/media/sarah.a43da100.bin";